import { Dispatch } from "react";
import {
  MyLocatorInventoryActions,
  setCurrentPageAction,
  setPageRowSizeAction,
} from "./reducers/actions";

export const onRowsPerPageChange = (
  dispatch: Dispatch<MyLocatorInventoryActions>,
  updatedRowsPerPage: number
): void => {
  dispatch(setPageRowSizeAction(updatedRowsPerPage));
  dispatch(setCurrentPageAction(1));
};

export const onFirstPageClick = (
  dispatch: Dispatch<MyLocatorInventoryActions>
): void => {
  dispatch(setCurrentPageAction(1));
};

export const onPreviousPageClick = (
  dispatch: Dispatch<MyLocatorInventoryActions>,
  currentPage: number
): void => {
  dispatch(setCurrentPageAction(Math.max(currentPage - 1, 1)));
};

export const onNextClick = (
  dispatch: Dispatch<MyLocatorInventoryActions>,
  currentPage: number
): void => {
  dispatch(setCurrentPageAction(currentPage + 1));
};

export const onLastPageClick = (
  dispatch: Dispatch<MyLocatorInventoryActions>,
  pageRowSize: number,
  totalCount: number
): void => {
  dispatch(
    setCurrentPageAction(Math.max(Math.ceil(totalCount / pageRowSize), 1))
  );
};
